import { render } from "./AsSpacer.vue?vue&type=template&id=ebab9be4"
const script = {}

import "./AsSpacer.vue?vue&type=style&index=0&id=ebab9be4&lang=css"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__